import { render } from "./PlayVideo.vue?vue&type=template&id=822463d6"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"

import "./PlayVideo.vue?vue&type=style&index=0&id=822463d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__